import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=4774440c&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=4774440c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4774440c",
  null
  
)

export default component.exports